<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // declare message with an empty value
      message: "",
    };
  },
};
</script>

<style>


body,
html {
  height: 100%;
  width: 100%;
}
#app {
  min-height: 100%;
  position: relative;
  background: #fafafe
}
.radio-label{
  user-select: text;
}

.messageBox{
  width: 900px;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/App.vue